import { render, staticRenderFns } from "./vipManage.vue?vue&type=template&id=e7681536&scoped=true"
import script from "./vipManage.vue?vue&type=script&lang=js"
export * from "./vipManage.vue?vue&type=script&lang=js"
import style0 from "./vipManage.vue?vue&type=style&index=0&id=e7681536&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7681536",
  null
  
)

export default component.exports